import { MainMenu, FlexSpacer } from '@epam/promo';
import { MainMenuLogo } from '@epam/uui-components';
import { useUserStore } from 'store/user.store';
import { NavLink, useNavigate } from 'react-router-dom';
import logoImage from 'assets/icons/logo.svg';
import { UserProfile } from '../UserProfile';
import css from './Navbar.module.scss';
import { Route } from './Navbar.model';
import { useTaskSwitcher } from 'hooks';

const routes: Pick<Route, 'caption' | 'link'>[] = [
  {
    caption: 'User Management',
    link: { pathname: '/permissions' },
  },
  {
    caption: 'Task Management',
    link: { pathname: '/tasks' },
  },
];

export const Navbar = () => {
  const navigate = useNavigate();
  const switchTask = useTaskSwitcher();
  const user = useUserStore((state) => state.user);

  if (!user) {
    return (
      <MainMenu>
        <MainMenuLogo href="/" logoUrl={logoImage} />
      </MainMenu>
    );
  }

  if (user.role === 'GUEST') {
    return (
      <MainMenu>
        <MainMenuLogo href="/" logoUrl={logoImage} />
        <FlexSpacer priority={100500} />
        <UserProfile avatar={user.avatar} role={user.role} />
      </MainMenu>
    );
  }

  return (
    <MainMenu appLogoUrl={logoImage} logoLink={{ pathname: '/' }}>
      {routes
        .filter((route) =>
          user.role === 'ADMIN' ? route.caption !== 'User Management' : true,
        )
        .map(({ caption, link }) => (
          <NavLink
            key={caption}
            className={({ isActive }) => `${css['navlink__uui-link']} 
								${css['navlink__uui-button-box']} 
								${css['navlink__uui-enabled']} 
								${css['navlink__-clickable']} 
								${isActive && css['navlink__uui-active']}`}
            to={link}
            onClick={(e): void => {
              e.preventDefault();

              return link.pathname === '/tasks'
                ? navigate(link)
                : switchTask({
                    onSuccess: () => navigate(link),
                    onAbort: () => navigate(link),
                  });
            }}>
            <div className={css['navlink__uui-caption']}>{caption}</div>
          </NavLink>
        ))}
      <FlexSpacer priority={100500} />
      <UserProfile avatar={user.avatar} role={user.role} />
    </MainMenu>
  );
};
